export default function HeaderBar() {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Create Quote</h1>
          <p className="text-sm text-gray-500 mt-1">
            Create a one off quote for customer
          </p>
        </div>
      </div>
    </div>
  );
}
